import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PersonalService} from '../../../services/modules/personal.service';

interface EvaluationResponse {
  QuestionText: string;
  SelectedAnswerText: string;
  IsCorrect: boolean;
}

interface EvaluationSummary {
  Id: number;
  Passed: boolean;
  Score: number;
  ApprovalPercentage: number;
  Responses: EvaluationResponse[];
}

@Component({
  selector: 'app-dialog-trainings-evaluations-historical',
  templateUrl: './dialog-trainings-evaluations-historical.component.html',
  styleUrls: ['./dialog-trainings-evaluations-historical.component.scss']
})
export class DialogTrainingsEvaluationsHistoricalComponent implements OnInit {
  approvalPct?: number;
  displayEmployerName = '';
  evaluationSummary?: EvaluationSummary;

  constructor(private dialogRef: MatDialogRef<DialogTrainingsEvaluationsHistoricalComponent>,
              private personalService: PersonalService,
              @Inject(MAT_DIALOG_DATA) public data: { evaluationId: number, employerName: string, approvalPercentage?: number}) { }

  ngOnInit(): void {
    this.displayEmployerName = this.data?.employerName ?? (this.data as any)?.EmployerName ?? '';
    this.approvalPct = this.data?.approvalPercentage;
    this.loadEvaluationSummary();
  }

  loadEvaluationSummary(): void {
    this.personalService.getTrainingEvaluations(this.data.evaluationId).subscribe({
      next: (summary: EvaluationSummary) => {
        this.evaluationSummary = summary;
        if (this.approvalPct == null && summary?.ApprovalPercentage != null) {
          this.approvalPct = summary.ApprovalPercentage;
        }
      },
    });
  }

  get approvalPercentage(): number | undefined {
    return this.evaluationSummary?.ApprovalPercentage ?? this.data?.approvalPercentage;
  }

  get correctCount(): number {
    return this.evaluationSummary?.Responses.filter(r => r.IsCorrect).length ?? 0;
  }

  get incorrectCount(): number {
    return this.evaluationSummary ? this.evaluationSummary.Responses.length - this.correctCount : 0;
  }

  get correctPercentage(): number {
    return this.evaluationSummary ? Math.round(this.evaluationSummary.Score) : 0;
  }

  get incorrectPercentage(): number {
    return 100 - this.correctPercentage;
  }

  close(): void {
    this.dialogRef.close();
  }

}
